import styled from "styled-components";

export const StyledNumberOfRatingContainer = styled.div`
    margin-top: 16px;
`;
